var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M57.5714 4.375H4.41473C1.97902 4.375 0 6.35742 0 8.79102V61.209C0 63.6426 1.97902 65.625 4.41473 65.625H57.5714C60.0071 65.625 62 63.6426 62 61.209V8.79102C62 6.35742 60.0071 4.375 57.5714 4.375ZM18.7384 56.875H9.54911V27.6445H18.7522V56.875H18.7384ZM14.1437 23.6523C11.196 23.6523 8.81562 21.2871 8.81562 18.3887C8.81562 15.4902 11.196 13.125 14.1437 13.125C17.0777 13.125 19.4719 15.4902 19.4719 18.3887C19.4719 21.3008 17.0915 23.6523 14.1437 23.6523ZM53.1844 56.875H43.9951V42.6562C43.9951 39.2656 43.9259 34.9043 39.2205 34.9043C34.4321 34.9043 33.6987 38.5957 33.6987 42.4102V56.875H24.5094V27.6445H33.325V31.6367H33.4496C34.6812 29.3398 37.6844 26.9199 42.1545 26.9199C51.4545 26.9199 53.1844 32.9766 53.1844 40.8516V56.875Z","fill":"#0577AF"}));
}

Linkedin.defaultProps = {"width":"62","height":"70","viewBox":"0 0 62 70","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
